// extracted by mini-css-extract-plugin
export var formLink = "Form-module--formLink--2O7tZ";
export var submitBtn = "Form-module--submitBtn--s4_9d";